import React from 'react';
import { useFirestoreDocs } from '../hooks/useFirestoreDocs';
import MarkdownRenderer from '../components/MarkdownRenderer';

/**
 * Vista Dinámica de Documentación para Desarrolladores (Firestore + Redux + Markdown)
 */
export default function DeveloperDocs() {
  const { docs, loading } = useFirestoreDocs('desarrolladores');

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', fontWeight: 300 }}>
        Cargando documentación técnica...
      </div>
    );
  }

  return (
    <div className="developer-docs-container">
      {docs.map((docItem) => (
        <section key={docItem.id} id={docItem.id} className="doc-section" style={{ marginBottom: '2.5rem' }}>
          <MarkdownRenderer content={docItem.contenidoMarkdown} />
        </section>
      ))}
    </div>
  );
}
